<script>
import { menuItems } from "@/components/horizontal-menu";
import { mapGetters } from 'vuex';

export default {
  props: {
    collapsed: {
      type: Boolean,
      required: true
    }
  },

  emits: ["update:collapsed"],

  data() {
    return {
      isMobile: window.innerWidth < 768
    };
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    role() {
      return this.$cookies.get("userr");
    },

    permission() {
      try {
        return JSON.parse(this.getCookie("permission")) || [];
      } catch {
        return [];
      }
    },

    ...mapGetters('menu', ['menuCode', 'urlCode', 'featureFlags', 'menuName', 'customerName']),

    isCustomerAdmin() {
      return this.$cookies.get("ica") === 'true' || this.$cookies.get("ica") === true;
    },

    menu() {
    return  menuItems
    .filter(item => {
      if (this.role == null) return item.role === 0;
      if (item.role !== Number(this.role)) return false;

      if (
        Number(this.role) === 0 &&
        item.isForAdmin &&
        !this.isCustomerAdmin
      ) {
        return false;
      }

      if (item.subRole) {
        return this.permission.some(p => item.subRole.includes(p));
      }

      if (item.requires) {
        return item.requires.every(feature => this.featureFlags[feature]);
      }

      return true;
    })
    .map(item => {
      if (item.type === 'header') {
        return {
          header: true,
          title: item.isCampaignName ? this.menuName : this.$t(item.title),
          hiddenOnCollapse: item.hiddenOnCollapse,
          class: 'vsm--header '
        };
      }

      let href = item.link || '';

      if (!href) {
        href = this.urlCode;
        return {
          title: this.$t(item.label),
          icon: item.icon,
          href,
          external: true,
        };
      }

      if (href === '/menu-order' && this.menuCode) {
        href = `${href}?menuCode=${this.menuCode}`;
        return {
          title: this.$t(item.label),
          icon: item.icon,
          href,
          external: false,
        };
      }

      return {
        title: this.$t(item.label),
        icon: item.icon,
        href,
        external: false,
      };
    });
}
  

  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },

    toggleSidebar() {
      this.$emit("update:collapsed", !this.collapsed);
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    }
  }
};
</script>


<template>
<aside class="sidebar-wrapper" :class="{ collapsed }">

<div
  class="sidebar-header"
  :class="collapsed ? 'text-center' : 'float-right mr-2'"
>
  <button class="toggle-btn" @click="toggleSidebar">
    <span v-if="collapsed">☰</span>

    <img
      v-else
      alt="left"
      class="mr-2"
      width="20"
      src="@/assets/icons/double-arrow-left-white.svg"
      style="cursor: pointer;"
    />
  </button>
</div>


  <div class="sidebar-menu-wrapper">
    <div class="sidebar-logo text-center">
      <a href="/" style="cursor: pointer;">
        <img
          v-if="!collapsed"
          src="@/assets/images/logo-white.png"
          alt="Logo"
        />
      </a>
    </div>

    <sidebar-menu
      :menu="menu"
      :collapsed="collapsed"
      :hideToggle="true"
      :disableHover="isMobile"
      width="260px"
      class="app-sidebar"
    >
    </sidebar-menu>

  </div>

</aside>
</template>


<style scoped>

.sidebar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100vh;
  z-index: 1001;
  padding: 10px 0;
  background: linear-gradient(180deg, #1f2a44, #1b2540);
  box-shadow: 6px 0 20px rgba(0, 0, 0, 0.15);
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
}

.sidebar-wrapper.collapsed {
  width: 60px;
}

@media (max-width: 767px) {
  .sidebar-wrapper.collapsed,
  .sidebar-wrapper.collapsed .v-sidebar-menu,
  .sidebar-wrapper.collapsed ::v-deep .vsm--mobile-bg {
    width: 60px !important;
    max-width: 60px !important;
    overflow: hidden !important;
    transition: none !important;
  }

  .sidebar-wrapper.collapsed ::v-deep .vsm--dropdown,
  .sidebar-wrapper.collapsed ::v-deep .vsm--title,
  .sidebar-wrapper.collapsed ::v-deep .vsm--arrow {
    display: none !important;
  }
}


.sidebar-header {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
}

.sidebar-header.float-right {
  justify-content: flex-end;
}

.sidebar-header.text-center {
  justify-content: center;
}

.toggle-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.sidebar-menu-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  padding-bottom: 10px;
}

.sidebar-menu-wrapper::-webkit-scrollbar {
  display: none !important;
}

.sidebar-menu-wrapper {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sidebar-logo {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 0px;
  margin-bottom: 35px;
}

.sidebar-logo img {
  height: 80px;
}

.sidebar-wrapper.collapsed .sidebar-logo {
  display: none;
}

.app-sidebar {
  background: transparent;
  position: fixed;
  z-index: 1050;
}

.v-sidebar-menu {
  position: relative !important;
}

.v-sidebar-menu .vsm-title,
.v-sidebar-menu .vsm-icon {
  color: #ffffff !important;
  font-weight: 500;
}

.v-sidebar-menu .vsm-item {
  margin: 6px 10px;
  border-radius: 14px;
  transition: background 0.25s ease;
}

.v-sidebar-menu .vsm-item:hover {
  background: #D4AF37 !important
}

.v-sidebar-menu .vsm-item.active {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.18),
    rgba(255, 255, 255, 0.05)
  );
}

.v-sidebar-menu .vsm-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 15%;
  width: 4px;
  height: 70%;
  background: #ffffff;
  border-radius: 0 4px 4px 0;
}



.sidebar-header-item {
  color: #D4AF37;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  padding: 8px 15px;
  position: relative;
  margin-top: 10px;
  cursor: default; /* no hover */
}

.sidebar-header-item::before {
  content: '';
  display: block;
  height: 1px;
  background: rgba(255, 255, 255, 0.2); /* light horizontal line */
  margin-bottom: 5px;
}


.vsm-divider {
  height: 1px;
  margin: 10px 16px;
  background: rgba(238, 233, 233, 0.15);
}


::v-deep .v-sidebar-menu .vsm--header {
    color: #9b9999;
    font-size: 10px;
}

::v-deep .v-sidebar-menu .vsm--title {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    font-size: 14px;
}

</style>
